var map = {
	"./BNB.png": "77ec",
	"./BTC.png": "f590",
	"./DAI.png": "0ed0",
	"./ETH.png": "6c13",
	"./PYUSD.png": "7301",
	"./SOL.png": "6142",
	"./TON.png": "e197",
	"./USDC.png": "bf00",
	"./USDT.png": "e802",
	"./XRP.png": "0f5e",
	"./activity_auth.png": "3aa0",
	"./activity_invite.png": "29d8",
	"./activity_recharge.png": "f211",
	"./common_ai.png": "d146",
	"./common_help.png": "5a1b",
	"./common_notice.png": "0f2e",
	"./common_positon.png": "feb2",
	"./common_property.png": "211a",
	"./common_service.png": "2902",
	"./common_usertrade.png": "06ba",
	"./common_with.png": "39dd",
	"./heard.png": "5eea",
	"./home_auth.png": "8b70",
	"./home_b1.png": "ac10",
	"./home_b2.png": "d9ee",
	"./home_balance.png": "79a7",
	"./home_bg_i.png": "60c8",
	"./home_common.png": "1a6a",
	"./home_recharge.png": "d600",
	"./home_service.png": "02e7",
	"./i_change.png": "9b6f",
	"./logo.png": "4ffd",
	"./nodata.png": "d3e27",
	"./password_ico.png": "4423",
	"./qrcode.png": "a596",
	"./share_invite.png": "c21c",
	"./share_inviteList.png": "2880",
	"./share_out.png": "1c59",
	"./share_outList.png": "4786",
	"./welcome_1.png": "32ff",
	"./welcome_2.png": "9454",
	"./welcome_3.png": "e11d",
	"./welcome_4.png": "9066"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b967";